import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResultPage() {
  const [searchParams] = useSearchParams();
  const durum = searchParams.get("durum");
  const siparis = searchParams.get("siparis");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (siparis) {
      axios
        .get(`${API}/link-orders/status/${siparis}`)
        .then((res) => setOrder(res.data))
        .catch(() => {});
    }
  }, [siparis]);

  const success = durum === "basarili" && order?.status === "paid";

  return (
    <div data-testid="payment-result-page" className="flex min-h-screen flex-col bg-[#FDFBF7]">
      <header className="border-b-2 border-[#1A1A1A]">
        <div className="mx-auto flex max-w-7xl items-center px-4 py-3 md:px-8">
          <Link to="/" data-testid="result-logo-link">
            <img src="/assets/logo.png" alt="Deny's Burger & Fries logosu" className="h-12 w-auto" />
          </Link>
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-16">
        <div className="card-print w-full max-w-lg p-10 text-center">
          {durum === "basarili" ? (
            <>
              <CheckCircle size={48} strokeWidth={2} className="mx-auto text-[#1A7A3D]" />
              <h1 className="mt-4 text-3xl font-black uppercase tracking-tighter text-[#1A1A1A]">
                {success ? "Ödemeniz alındı!" : "Ödeme onaylanıyor..."}
              </h1>
              <p className="mt-3 text-sm font-medium text-[#4A4A4A]">
                Siparişiniz {order?.branch_name ? `${order.branch_name} şubesine ` : ""}iletiliyor.
                Şubeye geldiğinizde adınızı söylemeniz yeterli. Afiyet olsun!
              </p>
              {order && (
                <p data-testid="result-total" className="mt-4 inline-block border-2 border-[#1A1A1A] bg-[#FDFBF7] px-4 py-2 text-sm font-black uppercase tracking-wide text-[#1A1A1A]">
                  Tutar: ₺{order.total}
                </p>
              )}
            </>
          ) : durum === "nakit" ? (
            <>
              <CheckCircle size={48} strokeWidth={2} className="mx-auto text-[#1A7A3D]" />
              <h1 className="mt-4 text-3xl font-black uppercase tracking-tighter text-[#1A1A1A]">
                Siparişiniz alındı!
              </h1>
              <p className="mt-3 text-sm font-medium text-[#4A4A4A]">
                Siparişiniz {order?.branch_name ? `${order.branch_name} şubesine ` : ""}iletildi.
                Ödemeyi şubede nakit olarak yapacaksınız. Geldiğinizde adınızı söylemeniz yeterli. Afiyet olsun!
              </p>
              {order && (
                <p data-testid="result-total" className="mt-4 inline-block border-2 border-[#1A1A1A] bg-[#FDFBF7] px-4 py-2 text-sm font-black uppercase tracking-wide text-[#1A1A1A]">
                  Şubede Ödenecek: ₺{order.total}
                </p>
              )}
            </>
          ) : durum === "basarisiz" ? (
            <>
              <XCircle size={48} strokeWidth={2} className="mx-auto text-[#E63946]" />
              <h1 className="mt-4 text-3xl font-black uppercase tracking-tighter text-[#1A1A1A]">
                Ödeme alınamadı
              </h1>
              <p className="mt-3 text-sm font-medium text-[#4A4A4A]">
                Kartınızdan tahsilat yapılmadı. Siparişinizi tekrar oluşturup
                ödemeyi yeniden deneyebilirsiniz.
              </p>
            </>
          ) : (
            <>
              <AlertCircle size={48} strokeWidth={2} className="mx-auto text-[#E63946]" />
              <h1 className="mt-4 text-3xl font-black uppercase tracking-tighter text-[#1A1A1A]">
                Bir sorun oluştu
              </h1>
              <p className="mt-3 text-sm font-medium text-[#4A4A4A]">
                Ödeme sonucu doğrulanamadı. Şüpheniz varsa şubeyle iletişime geçin.
              </p>
            </>
          )}
          <Link
            to="/"
            data-testid="result-home-link"
            className="btn-chunky mt-8 inline-flex bg-[#E63946] px-6 py-3 text-sm uppercase tracking-wide text-white"
          >
            Ana Sayfaya Dön
          </Link>
        </div>
      </main>
    </div>
  );
}
